export default "__VITE_ASSET__DxbNlNI6__"